




































import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { PartnerModule } from "@/store/modules/partner";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class ThgAboutList extends Vue {
  color = this.$store.state.config.color;

  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  get isWhiteLabelPartner(): boolean {
    return PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_QUOTE_AS_A_SERVICE;
  }

  notAuthenticatedItems = [
    {
      text: "navigation.TheAboutList.home",
      link: "/",
      icon: "mdi-home-outline"
    },
    {
      text: "navigation.TheAboutList.login",
      link: "/login",
      icon: "mdi-login"
    }
  ];

  wirkaufendeinethgItems = [
    {
      text: "navigation.TheAboutList.website",
      url: "https://www.wirkaufendeinethg.de/",
      target: "_blank",
      icon: "mdi-earth"
    }
  ];

  baseItems = [
    {
      text: "navigation.TheAboutList.faq",
      link: "/faq",
      icon: "mdi-frequently-asked-questions"
    },
    {
      text: "navigation.TheAboutList.imprint",
      link: "/impressum",
      icon: "mdi-information-outline"
    },
    {
      text: "navigation.TheAboutList.privacy",
      link: "/datenschutz",
      icon: "mdi-shield-sun-outline"
    },
    {
      text: "navigation.TheAboutList.terms",
      link: "/agbs",
      icon: "mdi-handshake-outline"
    }
  ];
}
